import { LoyaltyType, ProviderType, RoomProviderInfoViewModel } from '@api/v3';
export enum ACTIONS {
  SET_BASKET_ID,
  SET_LOYALTY,
  SET_MODAL,
  SET_VARIATIONS,
  SET_UNSELECTED_ROOMS,
  CLEAR,
}

export type Action =
  | { type: ACTIONS.SET_BASKET_ID; payload: string }
  | { type: ACTIONS.SET_MODAL; payload: LoyaltyType | null }
  | { type: ACTIONS.SET_VARIATIONS; payload: SelectedVariationProps[] }
  | { type: ACTIONS.SET_UNSELECTED_ROOMS; payload: number[] }
  | { type: ACTIONS.CLEAR };

export interface HotelDetailState {
  loyaltyType?: LoyaltyType | null;
  basketId: string;
  selectedVariations: SelectedVariationProps[];
  unSelectedRooms?: number[];
}

export type LoyaltyModalTypes =
  | 'TurkTelekom'
  | 'TurkTelekomPrime'
  | 'TurkTelekomPrimeBusiness'
  | 'KocAilem'
  | 'HopiKazanim';

export interface SelectedVariationProps {
  tabNumber: number;
  roomId: number;
  variationId: string;
  promotionInfoName?: string;
  totalDiscountedSellingPrice: number;
  cancelletionPolicyId: number;
  boardTypeId: number;
  provider: ProviderType | undefined;
  providerInfo?: RoomProviderInfoViewModel;
  promotionId: string;
  guests: {
    adultCount?: number;
    childrenBirthDates?: string[];
  };
  loyaltyType?: LoyaltyType | null;
  roomTypeId?: string;
  boardTypeName?: string;
  roomName?: string;
}
